import { createServiceStateApi } from './_serviceState';
export default createServiceStateApi('auth-config');
